import Phaser from 'phaser';
import TaskScene from '../scene/TaskScene';

export const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  // backgroundColor: '#555555',
  // Every render setting must live inside this block: Phaser resolves them with
  // `GetValue(config, 'render', config)`, so as soon as `render` exists it stops
  // falling back to the top level. A `transparent: true` left outside here is
  // silently ignored and the canvas turns opaque black.
  render: {
    transparent: true,
    // The target sheets are 512-px frames drawn at roughly 65-131 px, so the GPU
    // minifies them 4-8x. Without mipmaps that is a 2x2 tap over up to 64 texels and
    // the silhouette breaks into stair-steps. Phaser only builds a mip chain for
    // power-of-two textures (every sprite sheet is 8192x512); the rest, such as the
    // child background, keep plain LINEAR.
    mipmapFilter: 'LINEAR_MIPMAP_LINEAR',
  },
  scale: {
    parent: 'client-task-container',
    mode: Phaser.Scale.RESIZE,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    width: window.innerWidth,
    height: window.innerHeight,
  },
  scene: [new TaskScene('therapist')],
  banner: false,
};
